import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs';

const momentConstructor = dayjs;

@Pipe({ name: 'momentUtc' })
export class MomentUtcPipe implements PipeTransform {
  transform(value: Date | dayjs.Dayjs | string | number, format: string): string {
    return value
      ? momentConstructor(value)
          .utc()
          .format(format)
      : '- - -';
  }
}
